const WRITE_METHODS = new Set(["post", "put", "patch", "delete"]);

const normalizeShioriId = (value) => {
  if (value === null || value === undefined) return "";
  const normalized = String(value).trim();
  return normalized && normalized.length <= 255 ? normalized : "";
};

export const withShioriAccessContext = (
  shioriId,
  config = {},
  { recoverReadForbidden = false } = {},
) => ({
  ...config,
  rabiitripAccess: {
    ...(config.rabiitripAccess || {}),
    shioriId: normalizeShioriId(shioriId),
    recoverReadForbidden: Boolean(recoverReadForbidden),
  },
});

const parseRequestBody = (data) => {
  if (!data || typeof data !== "string") return data || {};
  try {
    return JSON.parse(data);
  } catch {
    return {};
  }
};

export const resolveShioriAccessRecovery = (config = {}, status) => {
  const method = String(config.method || "get").toLowerCase();
  const isWrite = WRITE_METHODS.has(method);
  const metadata = config.rabiitripAccess || {};
  const body = parseRequestBody(config.data);
  const shioriId = normalizeShioriId(
    metadata.shioriId ||
      config.params?.shiori_id ||
      config.params?.shioriId ||
      body.shiori_id ||
      body.shioriId,
  );

  if (!shioriId) return null;
  if (isWrite && (status === 403 || status === 404)) {
    return { shioriId, status, method };
  }
  if (!isWrite && status === 403 && metadata.recoverReadForbidden === true) {
    return { shioriId, status, method };
  }
  return null;
};
